import React from 'react';
import PropTypes from 'prop-types';
import Button from '@s/Button';
import Translation from '@s/Translation';

/**
 * need to translate
 */
const AddToOrderButton = props => {
    return(
        <Button className="button--primary" onClick={props.onClick} disabled={!!props.disabled && !props.loading} loading={!!props.loading}>
            <Translation>{"checkout__add_to_order"}</Translation>
        </Button>
    );
}

AddToOrderButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
};

export default AddToOrderButton;
